import { render } from "./Agent-item.vue?vue&type=template&id=6fcecdea&scoped=true"
import script from "./Agent-item.vue?vue&type=script&lang=js"
export * from "./Agent-item.vue?vue&type=script&lang=js"

import "./Agent-item.vue?vue&type=style&index=0&id=6fcecdea&scoped=true&lang=css"

import exportComponent from "/Users/thomas/Desktop/CNT/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcecdea"]])

export default __exports__